import * as getters from '../getters'

export function reduceFiltersToValues(filters) {
    for (let [key, value] of Object.entries(filters)) {
        if (typeof value === 'object' && value !== null) {
            if (value instanceof Array) {
                filters[key] = value.map((o) => o.value)
            } else {
                filters[key] = value.value
            }
        }
    }

    return filters
}

export function enterOnApplyButton() {
    $('body').on('keypress', (e) => {
        const target = e.target
        const code = e.keyCode ? e.keyCode : e.which

        if (code == 13) {
            if (
                target.closest('.select2') ||
                target.classList.contains('select2-search__field') ||
                target.classList.contains('table-datatable-filter-desktop-button') ||
                target.classList.contains('table-datatable-filter-element-button')
            ) {
                return
            }

            const filterItemContainer = document.querySelector('.table-datatable-filter-element-field.table-datatable-filter-element-field-show');
            if (filterItemContainer) {
                const applyButton = filterItemContainer.querySelector('button[data-datatable="table-datatable-filter-apply"]')
                if (applyButton) {
                    $(applyButton).trigger('click')
                    return
                }
            }

            const filterContainer = document.querySelector('.table-datatable-filter-desktop-container.d-block')
            if (filterContainer) {
                const filterButton = filterContainer.querySelector('button[data-datatable="table-datatable-filter-show-records"]')
                if (filterButton) {
                    $(filterButton).trigger('click')
                }
            }
        }
    })
}

export const not_wanted_elements = ['select2-search__field', 'search-ajax-checkbox']

/**
 * Dodaje możliwość pofiltrowania wyników na podstawie wybranych filtrów
 * @param instance
 * @param container
 */
export function initShowRecordsButton() {
    $('body').on('click', '[data-datatable="table-datatable-filter-show-records"]', (e) => {
        const container = getters.getContainer(e.target)
        const instance = getters.getCurrentTableInstance(e.target)
        reloadTable(instance, container)
    })
}

/**
 * Dodaje możliwość usuwania wszystkich filtrów
 * @param instance
 * @param container
 */
export function initClearAllFiltersButton(instance, container) {
    $('body').on('click', '[data-datatable="table-datatable-filter-clear-all-records"]', (e) => {
        const container = getters.getContainer(e.target)
        const instance = getters.getCurrentTableInstance(e.target)

        const promise = new Promise((resolve, reject) => {
            clearFilters(container)

            resolve(true)
        })

        promise.then((value) => {
            if (value) {
                clearAllSelectedLabelFilters(e.target)
                reloadTable(instance, container)
                closeFilterContainer(e.target)
            }
        })
    })
}

export function clearFilters(container) {
    container.querySelectorAll('.table-datatable-filter-element-container').forEach((filterElementContainer) => {
        const inputs = getFilterFields(filterElementContainer)

        inputs.each((key, input) => {
            $(input).prop('checked', false).prop('selected', false).removeAttr('checked').removeAttr('selected').trigger('change')

            if (!['checkbox', 'radio'].includes(input.type) && !input.hasAttribute('data-select2-init')) {
                $(input).val('')
            }

            if (input.hasAttribute('data-select2-init') && input.hasAttribute('multiple')) {
                if (input.options) {
                    Array.from(input.options).forEach((option) => {
                        option.selected = false
                    })
                }

                $(input).trigger('change.select2')
            }

            if (input.hasAttribute('data-select2-init') && !input.hasAttribute('multiple')) {
                $(input).val(null)

                $(input).trigger('change.select2')
            }
        })
    })
}

/**
 * Dodaje możliwość zamykania filtrów
 */
export function initCloseFilter() {
    $('body').on('click', '[data-datatable="table-datatable-filter-close"]', (e) => {
        closeFilterContainer(e.target)
    })
}

/**
 * Dodaje możliwość zamykania pola otwartego filtru
 */
export function initHideFilter() {
    $('body').on('click', '[data-datatable="table-datatable-filter-hide"]', (e) => {
        const target = e.currentTarget.closest('.table-datatable-filter-element-field')
        const container = e.currentTarget.closest('.table-datatable-filter-desktop-container')

        container.removeAttribute('style')

        $(target).removeClass('table-datatable-filter-element-field-show')
    })
}

/**
 * Dodaje możliwość pokazywania elementu filtra
 */
export function initShowFilterContainer() {
    $('body').on('click', '[data-datatable="table-datatable-filter-container-show"]', (e) => {
        window.dispatchEvent(
            new CustomEvent('show-filters-modal-' + e.currentTarget.dataset.tableId, {
                detail: {
                    dataset: e.currentTarget.dataset
                }
            })
        )
    })
}

/**
 * Dodaje możliwość filtrowania wyników na podstawie globalnej wyszukiwarki
 */
export function initCustomGlobalSearch() {
    let globalSearchTimeout = null

    $('body').on('keydown', '.table-datatable-global-searching input', (e) => {
        const currentTable = getters.getCurrentTableInstance(e.target)

        clearTimeout(globalSearchTimeout)

        globalSearchTimeout = setTimeout(() => {
            if (e.target.value.length >= 0) {
                currentTable.search(e.target.value).draw()
            }
        }, 500)
    })

    $('body').on('click', '.table-datatable-global-searching .clear-icon__hiddenable', (e) => {
        const currentTable = getters.getCurrentTableInstance(e.target)
        $('body .table-datatable-global-searching input').val('')

        clearTimeout(globalSearchTimeout)

        globalSearchTimeout = setTimeout(() => {
            currentTable.search('').draw()
        }, 500)
    })
}

/**
 * Przeładowuje tabelę
 * @param instance
 * @param container
 */
export function reloadTable(instance, container) {
    instance.search('').draw()
}

export function stateSaveParams(container, data) {
    const table = getters.getTable(container) // Pobieramy naszą tabelę
    const instanceId = getters.getInstanceId(table)
    const instance = window.datatableInstances[instanceId]
    setTimeout(()=> {
        $.ajax({
            url: route('datatable_states.store'),
            type: 'POST',
            dataType: 'json',
            data: {
                table_id: getters.getTableStateId(table),
                filters: JSON.stringify({
                    filters: instance.custom_filters,
                    ...data,
                    current_filter: instance.current_filter
                })
            }
        })
    },500)

}

export function searchAjaxCheckboxMethod(target, ids) {
    ids = typeof ids !== 'undefined' ? ids : null
    const container = target.closest('.table-datatable-filter-element-field')
    const results_element = container.querySelector('.search-ajax-checkbox-result')
    const checkbox_id = results_element.dataset.fieldId
    const checkbox_name = results_element.dataset.fieldName
    const value = target.value
    const url = results_element.dataset.ajaxUrl
    const instance = getters.getCurrentTableInstance(target)

    $.ajax({
        url: url,
        type: 'GET',
        dataType: 'json',
        data: {
            search: value,
            ids: ids
        },
        success: (d) => {
            results_element.querySelectorAll('input:not(:checked)').forEach((checkbox) => {
                checkbox.closest('.custom-control').remove()
            })

            Object.entries(d.items).forEach(([key, text]) => {
                if (!results_element.querySelector(`[name="${checkbox_name}"][value="${key}"]`)) {
                    results_element.insertAdjacentHTML('beforeend', `
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" ${ids && ids.includes(key) ? 'checked' : ''} class="search-ajax-checkbox-selector custom-control-input" name="${checkbox_name}" id="${checkbox_id}-${key}" value="${key}">
                            <label for="${checkbox_id}-${key}" class="custom-control-label">${text}</label>
                        </div>
                    `);
                }
            });

            instance.draw()
        }
    })
}
